export default __webpack_public_path__ + "f086c6f0446aef956d97843dd072d402.png";